import React from 'react';
import Imgix from 'react-imgix';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 40px;
  flex: 1;
  .colors-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  @media (max-width: 1200px) {
    .colors-container {
    }
  }
`;

const order = [
  'Red',
  'Pink',
  'Orange',
  'Yellow',
  'Green',
  'Teal',
  'Blue',
  'Navy',
  'Purple',
  'Grey',
  'Black',
  'Brown',
  'White',
  'Neutral'
];

const sortColors = colorsArr => {
  const sortedColors = [...colorsArr].sort((a, b) => {
    const aIndex = order.indexOf(a.name);
    const bIndex = order.indexOf(b.name);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    if (aIndex !== -1) {
      return -1;
    }

    if (bIndex !== -1) {
      return 1;
    }

    return 0;
  });

  const multiIdx = sortedColors.findIndex(color => color.name === 'Multi');
  let multi = [];

  if (multiIdx !== -1) {
    multi = sortedColors.splice(multiIdx, 1);
    sortedColors.push(...multi);
  }

  return sortedColors;
};

function Color({ colors, colorIds, setColorIds, className }) {
  const handleClick = colorId => {
    const isSelected = colorIds.some(id => id === parseInt(colorId));
    if (isSelected) {
      setColorIds(colorIds.filter(id => id !== parseInt(colorId)));
    } else {
      setColorIds([...colorIds, parseInt(colorId)]);
    }
  };

  return (
    <Wrapper className={className ? className : ''}>
      <Title>Color</Title>
      <div className="colors-container">
        {sortColors(colors).map((color, i) => {
          if (color.name === 'Multi') {
            return (
              <Multi
                title="Multi"
                className="multi-container"
                onClick={() => handleClick(color.id)}
                key={color.id}
                color={color.hex_code}
                selected={colorIds.some(id => id === parseInt(color.id))}
              >
                <Imgix
                  sizes="60px"
                  imgixParams={{ auto: 'compress,format' }}
                  src={'https://theinside.imgix.net/common/colors-wheel.svg'}
                  htmlAttributes={{
                    alt: 'Multi Color' // low quality image here
                  }}
                />
              </Multi>
            );
          }
          return (
            <ColorDot
              title={color.name}
              onClick={() => handleClick(color.id)}
              key={color.id}
              color={color.hex_code}
              selected={colorIds.some(id => id === parseInt(color.id))}
            />
          );
        })}
      </div>
    </Wrapper>
  );
}

export default Color;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;

  color: ${({ theme }) => theme.colors.charcoal};
`;

const Multi = styled.div`
  margin-bottom: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: inline-grid;
  margin-left: 10px;
  border-radius: 50%;
  border: ${({ selected }) =>
    selected ? '2px solid #A83569' : '1px solid white'};

  img {
    border-radius: 50%;
    border: ${({ selected }) => (selected ? '1px solid white' : 'none')};
    height: 20px;
    width: auto;
  }
`;

export const ColorDot = styled.span`
  margin-bottom: 5px;
  cursor: pointer;
  display: inline-block;
  margin-left: 5px;
  border-radius: 50%;
  background: ${({ color }) => color};
  border: ${({ color, selected }) =>
    selected
      ? '2px solid #fff'
      : color === 'white' || color === '#FFFFFF'
      ? '1px solid #C9C9C9'
      : '1px solid #fff'};
  height: 20px;
  width: 20px;
  max-width: 20px;

  box-shadow: ${({ color, selected }) =>
    selected ? '0 0 0 2px #a83569;' : 'none'};
`;
